import styled from '@emotion/styled';

const AttachmentSectionTitle = styled('h3')({
  marginBottom: 12,
  fontSize: '1rem',
  fontWeight: 500,
});

export default AttachmentSectionTitle;
